module.exports = __webpack_public_path__ + "whiplash-geo-logo-white.4f7eaa97.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/components/routes/images/whiplash-geo-logo-white.svg
// module id = TPw1
// module chunks = 0